if (!customElements.get('pdp-product')) {
  customElements.define(
    'pdp-product',
    class PdpProduct extends HTMLElement {
      connectedCallback() {
        this.initStoreModal();
        this.initGallery();
      }

      initGallery() {
        this.gallery = this.querySelector('[data-pdp-gallery]');
        if (!this.gallery) return;

        this.mains = Array.from(this.gallery.querySelectorAll('[data-pdp-main]'));
        this.thumbs = Array.from(this.gallery.querySelectorAll('[data-pdp-thumb]'));
        this.thumbsEl = this.gallery.querySelector('[data-pdp-thumbs]');
        if (!this.thumbs.length) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.selectMedia(thumb.dataset.mediaId, thumb));
        });
      }

      selectMedia(mediaId, activeThumb) {
        if (!mediaId) return;

        this.mains.forEach((main) => {
          const match = String(main.dataset.mediaId) === String(mediaId);
          main.classList.toggle('is-active', match);
          main.hidden = !match;
        });

        this.thumbs.forEach((thumb) => {
          const match = String(thumb.dataset.mediaId) === String(mediaId);
          thumb.classList.toggle('is-active', match);
          thumb.setAttribute('aria-selected', match ? 'true' : 'false');
        });

        if (activeThumb && this.thumbsEl) {
          activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }

      initStoreModal() {
        this.storeModal = this.querySelector('[data-pdp-store-modal]');
        if (!this.storeModal) return;

        this.storeMap = this.storeModal.querySelector('[data-pdp-store-map]');
        this.querySelector('[data-pdp-store-open]')?.addEventListener('click', () => this.openStoreModal());

        this.storeModal.querySelectorAll('[data-pdp-store-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeStoreModal());
        });

        this.boundStoreEscape = (event) => {
          if (event.key === 'Escape') this.closeStoreModal();
        };
      }

      openStoreModal() {
        if (!this.storeModal) return;
        if (this.storeMap && !this.storeMap.getAttribute('src')) {
          this.storeMap.setAttribute('src', this.storeMap.dataset.src);
        }
        this.storeModal.hidden = false;
        this.storeModal.classList.add('is-open');
        document.body.classList.add('pdp-store-modal-open');
        document.addEventListener('keydown', this.boundStoreEscape);
        this.storeModal.querySelector('[data-pdp-store-close].pdp-store-modal__close')?.focus();
      }

      closeStoreModal() {
        if (!this.storeModal) return;
        this.storeModal.hidden = true;
        this.storeModal.classList.remove('is-open');
        document.body.classList.remove('pdp-store-modal-open');
        document.removeEventListener('keydown', this.boundStoreEscape);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.boundStoreEscape);
        document.body.classList.remove('pdp-store-modal-open');
      }
    }
  );
}
